import withFormikWrapper from '../formik/withFormikWrapper';
import CleanDateInput from '../cleanDateInput';

export const CleanFormikDateInput = withFormikWrapper()(CleanDateInput);
